/**
 * Created by lihanying on 2017/7/7.
 */
import React from 'react'
import { Modal, Input, Select } from 'antd'

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      phoneError: {},
      phoneTypeIndex: 0,
      preInput: '',
    }
  }

  checkPhone = (phone) => {
    let phoneNumber = phone.replace(/\D/g, '')
    const area = this.props.regionList[this.state.phoneTypeIndex] //当前选中的区域
    let phoneSize //当前选中区域的号码长度
    if (area.name == '中国内地') {
      phoneSize = 11
    } else if (area.name == '中国澳门' || area.name == '中国香港') {
      phoneSize = 8
    } else if (area.name == '中国台湾') {
      phoneSize = 10
    }

    const data = { preInput: phone } //setData的对象
    if (phoneNumber.length == phoneSize) {
      data.phoneError = { state: false, status: '' }
      data.phone = phoneNumber
      sessionStorage.setItem('employee_phone', phoneNumber)
    } else if (phoneNumber.length > phoneSize) {
      data.phoneError = { state: true, status: `手机号码超过${phoneSize}位` }
    } else {
      data.phoneError = {
        state: true,
        status: `还有${phoneSize - phoneNumber.length}位`,
      }
    }
    this.setState(data)
  }

  render() {
    const { visible, userInfo, action, regionList } = this.props
    return (
      <div>
        <Modal
          title={action === '-1' ? '添加员工' : '修改人工信息'}
          visible={visible}
          onOk={() => {
            sessionStorage.setItem(
              'region_id',
              this.props.regionList[this.state.phoneTypeIndex].id
            )
            this.props.handleOk()
          }}
          onCancel={this.props.handleCancel}
          width="600px"
        >
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <div style={{ marginTop: '1rem' }}>
              <span className="info-span">员工账号:</span>
              <Input
                size="large"
                defaultValue={userInfo.account}
                style={{ width: '71%', marginLeft: '1rem' }}
                placeholder="请输入员工账号"
                onChange={(e) =>
                  sessionStorage.setItem('account', e.target.value)
                }
              />
            </div>
            <div style={{ marginTop: '1rem' }}>
              <span className="info-span">密码:</span>
              <Input
                type="password"
                size="large"
                style={{ width: '71%', marginLeft: '2.4rem' }}
                placeholder={
                  action === '-1'
                    ? '请输入员工密码'
                    : '请输入新的密码,可以不填写'
                }
                onChange={(e) =>
                  sessionStorage.setItem('password', e.target.value)
                }
              />
            </div>
            <div style={{ marginTop: '1rem' }}>
              <span className="info-span">员工姓名:</span>
              <Input
                size="large"
                defaultValue={userInfo.employee_name}
                style={{ width: '71%', marginLeft: '1rem' }}
                placeholder="请输入员工的名字"
                onChange={(e) =>
                  sessionStorage.setItem('employee_name', e.target.value)
                }
              />
            </div>
            <div style={{ marginTop: '1rem' }}>
              <span className="info-span">手机号码:</span>
              <Select
                style={{ marginLeft: '1rem' }}
                defaultValue={0}
                onChange={(phoneTypeIndex) => {
                  this.setState({ phoneTypeIndex }, () => {
                    this.checkPhone(this.state.preInput)
                  })
                }}
              >
                {regionList &&
                  regionList.map((v, index) => {
                    return (
                      <Select.Option key={index} value={index}>
                        {v.name}
                      </Select.Option>
                    )
                  })}
              </Select>
              <Input
                size="large"
                defaultValue={userInfo.employee_phone}
                style={{ width: '50%', marginLeft: '1rem' }}
                type="tel"
                placeholder="请输入员工手机号码"
                pattern="1\d{10}"
                onChange={(e) => this.checkPhone(e.target.value)}
              />
              {this.state.phoneError.state ? (
                <i className="weui_icon_info">{this.state.phoneError.status}</i>
              ) : (
                ''
              )}
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubEmployee/component/modal.js